export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/panels.f1930a6.svg";